import '../style.css';
import '../spikes/threejs/style.css';
import { startProductionPark } from './startProductionPark';

startProductionPark();
